/* eslint-disable react/jsx-props-no-spreading */
import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './ProgressBar.module.scss';

export interface IProgressBarProps extends HTMLAttributes<HTMLDivElement> {
  progress: number
  fraction?: number
}
const ProgressBar:React.FC<IProgressBarProps> = ({
  className, progress, fraction = 0, ...props
}) => (
  <div className={classNames(styles.progressBar, className)} {...props}>
    <div className={styles.track} qa-element="progress-bar-track">
      <div className={styles.progress} style={{ width: `${progress}%` }} />
    </div>
    <div className={styles.label}>{`${progress.toFixed(fraction)}%`}</div>
  </div>
);

export default ProgressBar;
